/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilSquareIcon20Solid = forwardRef('ToolPencilSquareIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 10.414V11.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293l7.025-7.025-2-2-7.025 7.025a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m19.47 2.53-1.29 1.29-2-2L17.47.53a.75.75 0 0 1 1.06 0l.94.94a.75.75 0 0 1 0 1.06Z" }),
        React.createElement("path", { d: "M6 2h7.879l-6.94 6.94A1.5 1.5 0 0 0 6.5 10v2A1.5 1.5 0 0 0 8 13.5h2a1.5 1.5 0 0 0 1.06-.44L18 6.122v7.88a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Z" })));
});
